<template>
  <div
    :class="['basis-copy-book-card', {'bg-img': bgImg}]"
    @click="clickHandler"
  >
    <div class="image-box">
      <lazy-component class="lazy-component">
        <van-image
          width="100%"
          height="100%"
          fit="fill"
          :src="item[avatarKey]"
        />
      </lazy-component>
    </div>
    <div class="info">
      <p class="title">
        <slot name="title" :item="item">
          {{ item.title }}
        </slot>
      </p>
      <span class="tag">
        <slot name="target" :target="target">
          {{ target.name }}
        </slot>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BasisCopyBookCard',
  props: {
    avatarKey: {
      type: String,
      default: 'avatar'
    },
    item: {
      type: Object,
      required: true,
      default: () => {}
    },
    targetItem: {
      type: [Object, undefined],
      default: () => {}
    },
    bgImg: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['teacher']),
    target () {
      return this.targetItem || this.teacher
    }
  },
  methods: {
    clickHandler () {
      this.$emit('clickHandler')
    }
  }
}
</script>

<style scoped lang="scss">
.basis-copy-book-card {
  font-size: 0;
  &.bg-img {
    @include bg-image-png('/copy-book/bg-img');
    background-size: 220px 100px;
    background-position: right bottom;
    background-repeat: no-repeat;
  }
  .image-box {
    @include wh(100%, calc(343px * 2 / 3));
    .lazy-component {
      @include wh(100%, 100%);
    }
  }
  .info {
    .title {
      @include sc($font-size-xlg, $color-text-heavy);
      @include lw(25px, 500);
      padding: 10px 0;
    }
    .tag {
      @include sc($font-size-base, $color-text-light);
    }
  }
}
</style>
